<template>
    <span
        class="text-danger float-left mr-1"
        v-if="convenio.idSituacaoConvenio != 9">
        <i
            class="fa fa-trash fa-lg icon-button"
            title="Excluir Lançamento"
            @click.stop="confirmarExcluir(prestacaoContasFinalLancamento.idPrestacaoContasFinal)"
        ></i>
    </span>
</template>

<script>

export default {

    props: {
        convenio: Object,
        prestacaoContasFinalLancamento: Object,
        dataServicos: {
            type: Object
        },
    },

    methods: {
        confirmarExcluir(id){
            this.$swal({
                title: 'Excluir',
                html: 'Deseja Excluir o Lançamento ?',
                icon: 'error',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.excluir(id)
                }
            })
        },

        excluir(id){
            this.$store.dispatch('addRequest')
            this.dataServicos.ExcluirPrestacaoFinal(id)
            .then(response => {
                if (response) {
                    if (response.success) {
                        this.$toast.success(
                            'Lançamento Excluído com sucesso',
                            'OK',
                            this.$toastConfig.success
                        )
                        this.$emit('atualizarLista')
                    }
                    else{
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },
    },
}
</script>
